import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Radio,
    Row,
    Select,
    TimePicker,
    Typography
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addOvertime, getOvertimeByUser } from "../../redux/rtk/features/overtime/overtimeSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const { TextArea } = Input;
const { Title } = Typography;

const UserOvertime = ({ drawer }) => {
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const [overtimeStart, setOvertimeStart] = useState({ date: null, time: null });
    const [overtimeEnd, setOvertimeEnd] = useState({ date: null, time: null });
    const [rewardType, setRewardType] = useState("Toil");
    const [payRate, setPayRate] = useState(null);
    const [overtimeLength, setOvertimeLength] = useState("0 Hours 0 Mins");
    const staffList = useSelector((state) => state.users?.list);
    const dispatch = useDispatch();
    const userId = getUserFromToken();
    const permissions = getPermissions();
    // console.log("pp", permissions)
    const hasPermission = (item) => {
        return permissions?.includes(item ? item : "");
    };

    useEffect(() => {
        // Only load all employees when applying OT for others (admin/role permission)
        if (hasPermission("update-role")) {
            dispatch(loadAllStaff({ status: true }));
        }
    }, [dispatch]);

    const calculateOvertimeLength = () => {
        if (overtimeStart.date && overtimeStart.time && overtimeEnd.date && overtimeEnd.time) {
            const startDateTime = new Date(
                Date.UTC(
                    overtimeStart.date.split('-')[0],
                    overtimeStart.date.split('-')[1] - 1,
                    overtimeStart.date.split('-')[2],
                    ...overtimeStart.time.split(':').map(Number)
                )
            );
            const endDateTime = new Date(
                Date.UTC(
                    overtimeEnd.date.split('-')[0],
                    overtimeEnd.date.split('-')[1] - 1,
                    overtimeEnd.date.split('-')[2],
                    ...overtimeEnd.time.split(':').map(Number)
                )
            );
            const diffMs = Math.abs(endDateTime - startDateTime);
            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
            setOvertimeLength(`${diffHrs} Hours ${diffMins} Mins`);
        }
    };

    useEffect(() => {
        calculateOvertimeLength();
    }, [overtimeStart, overtimeEnd]);

    const handleFormSubmit = (values) => {
        const formData = {
            ...values,
            userId: hasPermission("update-role") ? values.userId : userId,
            overtimeStart: overtimeStart.date && overtimeStart.time
                ? new Date(Date.UTC(
                    overtimeStart.date.split('-')[0],
                    overtimeStart.date.split('-')[1] - 1,
                    overtimeStart.date.split('-')[2],
                    ...overtimeStart.time.split(':').map(Number)
                ))
                : null,
            overtimeEnd: overtimeEnd.date && overtimeEnd.time
                ? new Date(Date.UTC(
                    overtimeEnd.date.split('-')[0],
                    overtimeEnd.date.split('-')[1] - 1,
                    overtimeEnd.date.split('-')[2],
                    ...overtimeEnd.time.split(':').map(Number)
                ))
                : null,
            rewardType: rewardType === "Payable" ? true : false,
            payRate: rewardType === "Payable" ? payRate : null,

        };

        setLoader(true);

        dispatch(addOvertime(formData))
            .then(() => {
                setLoader(false);
                form.resetFields();
                // dispatch(getAllOvertime());
                dispatch(getOvertimeByUser(userId));

                setOvertimeStart({ date: null, time: null });
                setOvertimeEnd({ date: null, time: null });
                setPayRate(null);
            })
            .catch((error) => {
                setLoader(false);
                toast.error("Error in logging overtime");
            });
    };

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-attendance"}>
                <Row className="mb-4">

                    <Col span={24}>

                        {(overtimeStart.time === null || overtimeStart.date === null ||
                            overtimeEnd.time === null || overtimeEnd.date === null) ? (
                            <p className='text-rose-500 text-sm font-medium mb-4' style={{ textAlign: 'left' }}>
                                * Please fill Date and Time for both Start and End
                            </p>
                        ) : null}
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            eventKey='overtime-form'
                            name='basic'
                            layout="vertical"
                            onFinish={handleFormSubmit}
                            autoComplete='off'>
                            <div>
                                {hasPermission("update-role") && (
                                    <Form.Item
                                        style={{ marginBottom: "10px" }}
                                        label='Employee'
                                        name='userId'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select an employee!",
                                            },
                                        ]}>
                                        <Select placeholder='Select Employee'
                                        showSearch allowClear
                                        filterOption={(input, option) =>
                                            String(option.children).toLowerCase().includes(input.toLowerCase())
                                        }>
                                            {staffList?.slice() // Create a copy to avoid mutating the original array
											.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((staff) => (
                                                <Select.Option key={staff.id} value={staff.id}>
                                                    {staff.firstName} {staff.lastName}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                )}

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='OT Start'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input start time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setOvertimeStart({ ...overtimeStart, date: dateString })
                                            }
                                            showToday={false}
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm"}
                                            onChange={(time, timeString) =>
                                                setOvertimeStart({ ...overtimeStart, time: timeString })
                                            }
                                            showNow={false}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='OT End'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input end time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setOvertimeEnd({ ...overtimeEnd, date: dateString })
                                            }
                                            showToday={false}
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm"}
                                            onChange={(time, timeString) =>
                                                setOvertimeEnd({ ...overtimeEnd, time: timeString })
                                            }
                                            showNow={false}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Reward'
                                >
                                    <Radio.Group
                                        onChange={(e) => setRewardType(e.target.value)}
                                        value={rewardType}
                                    >
                                        <Radio.Button value="Toil">Toil</Radio.Button>
                                        <Radio.Button value="Payable">Payable</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>

                                {rewardType === "Payable" && (
                                    <Form.Item
                                        style={{ marginBottom: "10px" }}
                                        label='Pay Rate'
                                        rules={[{ required: true, message: "Please select a pay rate!" }]}>
                                        <Select
                                            value={payRate}
                                            onChange={setPayRate}
                                            placeholder="Select Pay Rate">
                                            <Select.Option value="1.0">1.0 (Standard Rate)</Select.Option>
                                            <Select.Option value="1.25">1.25 (Time & Quarter )</Select.Option>
                                            <Select.Option value="1.33">1.33 (Time & Third)</Select.Option>
                                            <Select.Option value="1.5">1.5 (Time & Half) </Select.Option>
                                            <Select.Option value="2.0">2.0 (Double Time)</Select.Option>
                                            <Select.Option value="3.0">3.0 (Triple Time)</Select.Option>

                                        </Select>
                                    </Form.Item>
                                )}


                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Notes'
                                    name='note'
                                >
                                    <TextArea rows={4} placeholder="Add any notes" />
                                </Form.Item>

                                <div className="overtime-length mb-4" style={{ textAlign: 'left' }}>
                                    <strong>Overtime Length:</strong> {overtimeLength}
                                </div>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}>
                                    <Button
                                        type='primary'
                                        size='large'
                                        htmlType='submit'
                                        block
                                        loading={loader}
                                        disabled={
                                            overtimeStart.time === null ||
                                            overtimeStart.date === null ||
                                            overtimeEnd.time === null ||
                                            overtimeEnd.date === null
                                        }
                                    >
                                        Apply Overtime
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </UserPrivateComponent>
        </Fragment>
    );
};

export default UserOvertime;